import { Component, Input } from "@angular/core";
import { UpsellStep } from "src/app/models/upsell-step";

@Component({
    selector: "upsell-steps",
    templateUrl: "upsell-steps.html",
    styleUrls: ["upsell-steps.scss"],
})

export class UpsellStepsComponent {

  /**
   * @apiDescription Used to render steps
   * @apiParam {steps} Array containing steps objects
   * @apiParamExample {steps} Example input Array
   *  [{
   *    title: "",
   *    blocks: [
   *       `<p>Some text</p>`,
   *       `<p>Some text</p>`,
   *       `<p>Some text</p>`,
   *    ]
   *  }, {
   *    title: "Some title",
   *    blocks: [
   *       `<p>Some text</p>`,
   *    ]
   *  }]
   */
  @Input() steps: UpsellStep[] = [];
  @Input() stepLabel: string = 'step';
  @Input() newStepsStyle: boolean = false;

    constructor() {}

  trackByFn(index: number, item: UpsellStep): string | number {
    return item?.id || index;
  }
}
